module.exports = __webpack_public_path__ + "img/safe.a627a187.png";